<template>
  <div v-if="isShow" class="container-wrapper service-request-page fleet-request-page">
    <div
      v-if="get(fleetData, 'welcome.image')"
      class="fleet-request-page__image"
    >
      <img
        class="fleet-request-page__image-img"
        :src="getImageUrl"
      >
    </div>
    <section
      :class="{'with-image': get(fleetData, 'welcome.image')}"
      class="container"
    >
      <div class="service-request-page__form fleet-request-page__form">
        <div class="fleet-request-page__form-header">
          <h1 class="fleet-request-page__form-title" v-html="get(fleetData, 'welcome.title')" />
          <div class="fleet-request-page__form-image">
            <img :src="getLogoUrl">
          </div>
        </div>
        <div v-show="!tuType" class="service-request-page__form-fields fleet-request-page__fields">
          <!-- model input  -->
          <BaseAutoComp
            ref="autocomplete"
            v-model="form.model"
            :label="get(fleetData, 'form.model.label')"
            :required="get(fleetData, 'form.model.required')"
            :errorMsg="errorMsgs.model"
            :items="get(fleetData, 'form.model.items')"
          />

          <!-- city select  -->
          <BaseSelect
            v-model="form.city_id"
            :items="get(fleetData, 'form.city_id.items')"
            :label="get(fleetData, 'form.city_id.label')"
            :placeholder="get(fleetData, 'form.city_id.placeholder')"
            :required="get(fleetData, 'form.city_id.required')"
            :errorMsg="errorMsgs.city_id"
            class="service-request-page__form-input"
            @input="fetchDealer"
          />

          <!-- dealer select  -->
          <BaseSelect
            v-model="form.dealer_id"
            :items="dealerItems"
            :label="get(fleetData, 'form.dealer_id.label')"
            :placeholder="get(fleetData, 'form.dealer_id.placeholder')"
            :required="get(fleetData, 'form.dealer_id.required')"
            :errorMsg="errorMsgs.dealer_id"
            class="service-request-page__form-input"
            @input="resetService"
          />

          <!-- service select  -->
          <BaseSelect
            v-model="form.service_id"
            :items="serviceItems"
            :label="get(fleetData, 'form.service_id.label')"
            :placeholder="get(fleetData, 'form.service_id.placeholder')"
            :required="get(fleetData, 'form.service_id.required')"
            :errorMsg="errorMsgs.service_id"
            class="service-request-page__form-input"
          />

          <!-- gender select  -->
          <BaseSelect
            v-model="form.appeal"
            :items="get(fleetData, 'form.appeal.items')"
            :label="get(fleetData, 'form.appeal.label')"
            :placeholder="get(fleetData, 'form.appeal.placeholder')"
            :required="get(fleetData, 'form.appeal.required')"
            :errorMsg="errorMsgs.appeal"
            class="service-request-page__form-input"
          />

          <!-- surname input  -->
          <BaseInput
            v-model="form.last_name"
            :label="get(fleetData, 'form.last_name.label')"
            :required="get(fleetData, 'form.last_name.required')"
            :errorMsg="errorMsgs.last_name"
            class="service-request-page__form-input"
          />

          <!-- name input  -->
          <BaseInput
            v-model="form.first_name"
            :label="get(fleetData, 'form.first_name.label')"
            :required="get(fleetData, 'form.first_name.required')"
            :errorMsg="errorMsgs.first_name"
            class="service-request-page__form-input"
          />

          <!-- pnone input  -->
          <BaseInput
            v-model="form.phone"
            :label="get(fleetData, 'form.phone.label')"
            :required="get(fleetData, 'form.phone.required')"
            :errorMsg="errorMsgs.phone"
            type="tel"
            class="service-request-page__form-input"
          />

          <!-- email input  -->
          <BaseInput
            v-model="form.email"
            :label="get(fleetData, 'form.email.label')"
            :required="get(fleetData, 'form.email.required')"
            :errorMsg="errorMsgs.email"
            type="email"
            class="service-request-page__form-input"
          />

          <!-- edrpo input  -->
          <BaseInput
            v-model="form.edrpo"
            :label="get(fleetData, 'form.edrpo.label')"
            :required="get(fleetData, 'form.edrpo.required')"
            :disabled="Boolean(get($route.query, 'edrpo') && form.edrpo)"
            :defaultValue="get(fleetData, 'form.edrpo.value')"
            :errorMsg="errorMsgs.edrpo"
            class="service-request-page__form-input"
          />

          <!-- company name input  -->
          <BaseInput
            v-model="form.company_name"
            :label="get(fleetData, 'form.company_name.label')"
            :required="get(fleetData, 'form.company_name.required')"
            :defaultValue="get(fleetData, 'form.company_name.value')"
            :disabled="blockCompanyName"
            :errorMsg="errorMsgs.company_name"
            class="service-request-page__form-input"
          />
          <!-- state input  -->
          <BaseInput
            v-model="form.state_number"
            :label="get(fleetData, 'form.state_number.label')"
            :required="get(fleetData, 'form.state_number.required')"
            :errorMsg="errorMsgs.state_number"
            class="service-request-page__form-input"
          />

          <!-- vin number input  -->
          <BaseInput
            v-model="form.vin_number"
            :label="get(fleetData, 'form.vin_number.label')"
            :required="get(fleetData, 'form.vin_number.required')"
            :errorMsg="errorMsgs.vin_number"
            class="service-request-page__form-input"
          />

          <!-- comment textarea  -->
          <BaseInput
            v-model="form.comment"
            :label="get(fleetData, 'form.comment.label')"
            :required="get(fleetData, 'form.comment.required')"
            :errorMsg="errorMsgs.comment"
            type="textarea"
            class="service-request-page__form-input"
          />

          <!-- date datepicker  -->
          <BaseDatePicker
            v-if="fleetData.form && fleetData.form.date_time && showDatePicker"
            ref="datePicker"
            :label="get(fleetData, 'form.date_time.label')"
            :required="get(fleetData, 'form.date_time.required')"
            :buttonsText="get(fleetData, 'form.date_time.buttonText')"
            :options="datePickerOptions"
            :errorMsg="errorMsgs.date_time"
            :class="[
              'service-request-page__form-input',
              {disabled: !datePickerOptions && dealerItems}
            ]"
            @input="form.date_time = $event"
          />
        </div>
        <div v-show="tuType" class="service-request-page__form-fields fleet-request-page__fields">
          <!-- city select  -->
          <BaseSelect
            v-model="form.city_id"
            :items="get(fleetData, 'form.city_id.items')"
            :label="get(fleetData, 'form.city_id.label')"
            :placeholder="get(fleetData, 'form.city_id.placeholder')"
            :required="get(fleetData, 'form.city_id.required')"
            :errorMsg="errorMsgs.city_id"
            class="service-request-page__form-input"
            @input="fetchDealer"
          />

          <!-- dealer select  -->
          <BaseSelect
            v-model="form.dealer_id"
            :items="dealerItems"
            :label="get(fleetData, 'form.dealer_id.label')"
            :placeholder="get(fleetData, 'form.dealer_id.placeholder')"
            :required="get(fleetData, 'form.dealer_id.required')"
            :errorMsg="errorMsgs.dealer_id"
            class="service-request-page__form-input"
            @input="resetService"
          />

          <!-- service select  -->
          <BaseSelect
            v-model="form.service_id"
            :items="serviceItems"
            :label="get(fleetData, 'form.service_id.label')"
            :placeholder="get(fleetData, 'form.service_id.placeholder')"
            :required="get(fleetData, 'form.service_id.required')"
            :errorMsg="errorMsgs.service_id"
            class="service-request-page__form-input"
          />

          <!-- comment textarea  -->
          <BaseInput
            v-model="form.comment"
            :label="get(fleetData, 'form.comment.label')"
            :required="get(fleetData, 'form.comment.required')"
            :errorMsg="errorMsgs.comment"
            type="textarea"
            class="service-request-page__form-input"
          />

          <!-- odometer  -->
          <BaseInput
            v-model="form.odometer"
            fieldType="number"
            :label="get(fleetData, 'form.odometer.label')"
            :required="true"
            :errorMsg="errorMsgs.odometer"
            class="service-request-page__form-input"
          />

          <!-- date datepicker  -->
          <BaseDatePicker
            v-if="fleetData.form && fleetData.form.date_time && showDatePicker"
            ref="datePicker"
            :label="get(fleetData, 'form.date_time.label')"
            :required="get(fleetData, 'form.date_time.required')"
            :buttonsText="get(fleetData, 'form.date_time.buttonText')"
            :options="datePickerOptions"
            :errorMsg="errorMsgs.date_time"
            :class="[
              'service-request-page__form-input',
              {disabled: !datePickerOptions && dealerItems}
            ]"
            @input="form.date_time = $event"
          />

          <!-- surname input  -->
          <BaseInput
            v-model="form.last_name"
            :label="get(fleetData, 'form.last_name.label')"
            :required="get(fleetData, 'form.last_name.required')"
            :errorMsg="errorMsgs.last_name"
            :disabled="true"
            class="service-request-page__form-input"
          />

          <!-- name input  -->
          <BaseInput
            v-model="form.first_name"
            :label="get(fleetData, 'form.first_name.label')"
            :required="get(fleetData, 'form.first_name.required')"
            :errorMsg="errorMsgs.first_name"
            :disabled="true"
            class="service-request-page__form-input"
          />

          <!-- pnone input  -->
          <BaseInput
            v-model="form.phone"
            :label="get(fleetData, 'form.phone.label')"
            :required="get(fleetData, 'form.phone.required')"
            :errorMsg="errorMsgs.phone"
            type="tel"
            class="service-request-page__form-input"
          />

          <!-- email input  -->
          <BaseInput
            v-model="form.email"
            :label="get(fleetData, 'form.email.label')"
            :required="get(fleetData, 'form.email.required')"
            :errorMsg="errorMsgs.email"
            :disabled="true"
            type="email"
            class="service-request-page__form-input"
          />

          <!-- edrpo input  -->
          <BaseInput
            v-model="form.edrpo"
            :label="get(fleetData, 'form.edrpo.label')"
            :required="get(fleetData, 'form.edrpo.required')"
            :disabled="true"
            :errorMsg="errorMsgs.edrpo"
            class="service-request-page__form-input"
          />

          <!-- company name input  -->
          <BaseInput
            v-model="form.company_name"
            :label="get(fleetData, 'form.company_name.label')"
            :required="get(fleetData, 'form.company_name.required')"
            :errorMsg="errorMsgs.company_name"
            :disabled="true"
            class="service-request-page__form-input"
          />

          <!-- state input  -->
          <BaseInput
            v-model="form.mark"
            :label="get(fleetData, 'form.mark.label')"
            :required="get(fleetData, 'form.mark.required')"
            :disabled="true"
            :errorMsg="errorMsgs.mark"
            class="service-request-page__form-input"
          />

          <!-- vin number input  -->
          <BaseInput
            v-model="form.model"
            :label="get(fleetData, 'form.model.label')"
            :required="get(fleetData, 'form.model.required')"
            :disabled="true"
            :errorMsg="errorMsgs.model"
            class="service-request-page__form-input"
          />

          <!-- state input  -->
          <BaseInput
            v-model="form.state_number"
            :label="get(fleetData, 'form.state_number.label')"
            :required="get(fleetData, 'form.state_number.required')"
            :disabled="true"
            :errorMsg="errorMsgs.state_number"
            class="service-request-page__form-input"
          />

          <!-- vin number input  -->
          <BaseInput
            v-model="form.vin_number"
            :label="get(fleetData, 'form.vin_number.label')"
            :required="get(fleetData, 'form.vin_number.required')"
            :disabled="true"
            :errorMsg="errorMsgs.vin_number"
            class="service-request-page__form-input"
          />
        </div>
      </div>

      <div v-if="getFleet.hintText" class="service-request-page__editor-wrapper">
        <p class="service-request-page__editor" v-html="getFleet.hintText" />
      </div>

      <div class="service-request-page__policy">
        <BaseCheckbox
          v-model="form.policy"
          :errorMsg="errorMsgs.policy"
        >
          <span class="simple-link">
            {{ getFleet.policyLabel }}
            <RouterLink
              to="/policy-fleet"
              class="simple-link"
            >
              {{ getFleet.policyLink }}
            </RouterLink>
          </span>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__pd">
        <BaseCheckbox v-model="form.marketing" :errorMsg="errorMsgs.marketing">
          <span class="simple-link">
            {{ getFleet.marketingLabel }}
            <RouterLink to="/marketing-fleet" class="simple-link">
              {{ getFleet.marketingLink }}
            </RouterLink>
          </span>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__submit-button-container">
        <BaseButton
          :disabled="!form.policy || isLoading"
          @click="submitForm"
        >
          {{ getFleet.submitButtonText }}
        </BaseButton>
      </div>
    </section>
  </div>
</template>

<script>
// import router from '@/router'
  import { config } from '../config'
  import get from 'lodash/get'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'FleetPage',
    data () {
      return {
        blockCompanyName: false,
        search: '',
        isShow: false,
        fleetData: null,
        pageData: {},
        form: '',
        dealerItems: (this.fleetData && this.fleetData.dealer_id.items) || [],
        componentReady: false,
        showDatePicker: true,
        errorMsgs: {},
        tuType: false,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters(['getMain', 'isLoad', 'getFleet', 'getPhoneType']),
      getImageUrl () {
        if (!this.fleetData.welcome.image) return
        // console.log(config.API + this.fleetData.welcome.image.originalSrc)
        return config.API + this.fleetData.welcome.image.originalSrc
      },

      getLogoUrl () {
        if (!this.fleetData.welcome.logo) return
        // console.log(config.API + this.fleetData.welcome.image.originalSrc)
        return config.API + this.fleetData.welcome.logo.originalSrc
      },

      datePickerOptions () {
        const dealerId = this.form.dealer_id
        let items = get(this.fleetData, 'form.date_time.options')
        this.dealerItems.forEach(({ value, workPeriod, requestServiceIn }) => {
          if (value === dealerId) {
            items = { datePickerStep: 60, schedule: workPeriod, requestServiceIn, dealerId: value }
          }
        })
        return items
      },
      queryCity () {
        const cityId = Number(this.$route.query.city)
        return isNaN(cityId) ? undefined : cityId
      },
      serviceItems () {
        const dealerId = this.form.dealer_id
        let items = (this.fleetData && this.fleetData.form.service_id.items) || []
        this.dealerItems.forEach(({ value, services }) => {
          if (value === dealerId) {
            items = services
          }
        })
        return items
      }
    },

    async mounted () {
      await window.axios
        .get(this.$router.currentRoute.fullPath)
        .then(response => {
          this.fleetData = response.data.data

          if (response && response.data.data.driverTu !== null) {
            this.tuType = true
          }

          if (this.$router.currentRoute.query.city) {
            setTimeout(() => {
              this.fetchDealer(this.$router.currentRoute.query.city, true)
            }, 300)
          }

          setTimeout(() => {
            this.blockCompanyName = Boolean(this.$route.query.edrpo && this.form.company_name)
          }, 200)

          // // Логіка, яка залежить від this.tuType
          if (this.tuType === false) {
            this.form = this.getDefaultForm()
          } else {
            this.form = this.getDefaultFormForDriverTu()
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.isShow = true))
    },

    created () {
      // console.log('router', this.$router)
      this.get = get
      if (this.queryCity) {
        this.fetchDealer(this.queryCity, true)
      }

      if (this._.get(this.$route, 'query.country')) {
        this.$store.commit('setCurrentCountry', this.$route.query.country)
      }

    },
    watch: {
      'dealerItems': {
        handler () {
          if (this.dealerItems.length === 1) {
            this.form.dealer_id = this.dealerItems[0].value
          }
        }
      }
    },
    methods: {
      ...mapActions(['submitServiceRequest']),
      getDefaultForm () {
        return {
          model: '',
          periodId: '',
          dealer_id: this.$route.query.dealer && Number(this.$route.query.dealer),
          appeal: '',
          first_name: '',
          edrpo: this.$route.query.edrpo || '',
          last_name: '',
          company_name: this.fleetData.form.company_name.value || '',
          state_number: '',
          city_id: this.$route.query.city && Number(this.$route.query.city),
          service_id: this.$route.query.service && Number(this.$route.query.service),
          phone: this.getPhoneType === '+373' ? '' : this.getPhoneType,
          email: '',
          date_time: '',
          comment: '',
          vin_number: '',
          contact_method: 1,
          policy: false,
          marketing: false
        }
      },
      getDefaultFormForDriverTu () {
        return {
          model: this.fleetData.driverTu.model,
          mark: this.fleetData.driverTu.mark,
          periodId: '',
          dealer_id: this.$route.query.dealer && Number(this.$route.query.dealer),
          appeal: '',
          first_name: this.fleetData.driverTu.name,
          edrpo: this.fleetData.driverTu.edrpo || '',
          last_name: this.fleetData.driverTu.surname || '',
          company_name: this.fleetData.driverTu.company_name || '',
          state_number: this.fleetData.driverTu.state_number || '',
          city_id: this.$route.query.city && Number(this.$route.query.city),
          service_id: this.$route.query.service && Number(this.$route.query.service),
          phone: this.fleetData.driverTu.phone || '',
          email: this.fleetData.driverTu.email || '',
          date_time: '',
          comment: '',
          vin_number: this.fleetData.driverTu.vin || '',
          contact_method: 1,
          policy: false,
          marketing: false
        }
      },
      async clearForm () {
        this.$refs.autocomplete.value = ''
        this.form = this.getDefaultForm()
        const inputs = [...document.querySelectorAll('.input-wrapper input, .select-autocomplete input, .input-wrapper textarea')]
        inputs.forEach(input => {
          input.value = ''
        })
        this.dealerItems = []
        this.showDatePicker = false
        await this.$nextTick()
        this.showDatePicker = true
      },
      async submitForm () {
        this.errorMsgs = {}
        this.isLoading = true

        const payload = {
          ...this.form,
          subtype: this.fleetData.form.subtype.value,
          date_time: this.form.date_time && this.form.date_time / 1000 // timestamp in seconds, not miliseconds
        }

        const errorFn = (errors) => {
          if (typeof errors !== 'object') {
            console.warn('response errors is not a object', { errors })
          }
          Object.keys(errors)
            .forEach(errKey => {
              this.$set(this.errorMsgs, errKey, errors[errKey])
            })
        }

        try {
          const errors = await this.submitServiceRequest({
            submitUrl: this.fleetData.formSubmitUrl,
            form: payload,
            formName: 'fleet'
          })

          if (errors.title) {
            await this.clearForm()
            this.isLoading = false
            this.$router.push({ name: 'thank-you-fleet', params: errors })
          } else {
            errorFn(errors)
          }
        } catch (e) {
          this.isLoading = false
          const errors = e && e.response && e.response.data
          console.error('FAILED: submitServiceRequest')
          console.log({ e })
          errorFn(errors)
          // this.$router.push({ name: 'not-found' })
        }
      },
      async fetchDealer (cityId, isFromQuery) {
        const edrpo = this.$router.currentRoute.query.edrpo

        if (isNaN(Number(cityId)) && !edrpo) {
          this.dealerItems = []
          console.warn('City id or edrpo is not valid ', { cityId })
          return
        }

        const paramsSend = {}
        if (!isNaN(Number(cityId))) paramsSend.city = cityId
        if (edrpo) paramsSend.edrpo = edrpo

        const { data } = await window.axios.get(this.fleetData.dealerListUrl, { params: paramsSend }).catch(e => console.warn('Fetch Dealer error', { e }))
        if (!isFromQuery) {
          this.form.dealer_id = ''
          this.form.date_time = ''
          this.$refs.datePicker.date = ''
          this.$refs.datePicker.time = ''
          this.resetService()
        }
        this.dealerItems = data
      },
      resetService () {
        this.form.service_id = ''
        this.resetDatePicker()
      },
      resetDatePicker () {
        this.form.date_time = ''
        this.$refs.datePicker.date = ''
        this.$refs.datePicker.time = ''
      }
    }
  }
</script>

<style lang="scss">
.fleet-request-page {
  max-width: 100% !important;
  padding: 0 !important;
  background: rgb(255, 255, 255);
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) -9%, rgba(117, 116, 115, 1) 100%);

  @include mobile {
    margin-top: -15px !important;
  }

  &__image {
    position: relative;
    width: 100%;
    min-height: 700px;
    margin-top: -40px;

    @media (max-width: 1279px) {
      min-height: 400px;
      margin-top: 0;
    }

    @include mobile {
      min-height: 300px;
    }

    &-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-position: center;

      @include object-fit-cover();
    }
  }

  &__form {
    padding-top: 50px;

    @include mobile {
      padding-top: 20px;
    }

    &-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 30px;
    }

    &-title {
      color: $c-gray-dark;
      text-align: left;

      span {
        display: block;
        font-size: 24px;
        font-weight: normal;
      }
    }

    &-image {
      img {
        width: 80px;

        @include mobile {
          width: 60px;
        }
      }
    }
  }

  &__column {
    width: calc(50% - 35px);

    @include mobile {
      width: 100%;
    }
  }

  .container {
    position: relative;
    max-width: 800px;
    padding: 30px;
    background-color: $c-white;

    @include mobile {
      padding: 15px;
    }

    &.with-image {
      margin-top: -140px;

      @media (max-width: 768px) {
        margin-top: 0;
      }
    }
  }
}
</style>
